module.exports = __webpack_public_path__ + "static/media/mais-detail.a7e6cf3a.png";